export const POST_PROFILE = 'POST_PROFILE';
export const POST_TYPE = 'POST_TYPE';
export const POST_CONTENT = 'POST_CONTENT';
export const POST_SETTINGS = 'POST_SETTINGS';
export const POST_CONFIRMATION = 'POST_CONFIRMATION';

export type StepType =
    | typeof POST_PROFILE
    | typeof POST_TYPE
    | typeof POST_CONTENT
    | typeof POST_SETTINGS
    | typeof POST_CONFIRMATION;

type SchedulerStepType = {
    content: string;
    id: number;
    step: StepType;
};

function getCommonSteps(previousSteps: SchedulerStepType[]) {
    const previousStepsNumber = previousSteps?.length ?? 0;

    return [
        {
            content: 'scheduler_funnel.steps.type',
            id: 1 + previousStepsNumber,
            step: POST_TYPE
        },
        {
            content: 'scheduler_funnel.steps.content',
            id: 2 + previousStepsNumber,
            step: POST_CONTENT
        },
        {
            content: 'scheduler_funnel.steps.settings',
            id: 3 + previousStepsNumber,
            step: POST_SETTINGS
        },
        {
            content: 'scheduler_funnel.steps.confirmation',
            id: 4 + previousStepsNumber,
            step: POST_CONFIRMATION
        }
    ];
}

export function getSteps(fromGroup: boolean) {
    const firstSteps = (
        fromGroup ? [{ content: 'scheduler_funnel.steps.profile', id: 1, step: POST_PROFILE }] : []
    ) as SchedulerStepType[];
    return [...firstSteps, ...getCommonSteps(firstSteps)] as SchedulerStepType[];
}
